import { render } from "./WordListMemoryRecognition.vue?vue&type=template&id=90bc07e4&scoped=true"
import script from "./WordListMemoryRecognition.vue?vue&type=script&lang=js"
export * from "./WordListMemoryRecognition.vue?vue&type=script&lang=js"

import "./WordListMemoryRecognition.vue?vue&type=style&index=0&id=90bc07e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90bc07e4"]])

export default __exports__